import React, { useEffect, useState } from "react";
import { Box, Stepper, Step, StepLabel, SnackbarContent } from "@mui/material";
import ParcelInformationForm from "./parcelInformationForm";
import DateTimeForm from "./dateTimeForm";
import PersonalInformationForm from "./personalInformationForm";
import { createSale } from "../service/api";
import {
  mergeTimeAndDate,
  processArray,
  retrieveData,
  trackStepCompletion,
  pageViewed,
} from "../helper/helper";
import Snackbar from "@mui/material/Snackbar";
import ReactGA from "react-ga4";
import Thankyou from "./thankyou";
import ModalWrapper from "./modal";
import BookingSummary from "./bookingSummary";
import TimerToast from "./sessionTimer";

const steps = ["Get Instant Quote", "Choose Date / Time", "Enter Contact Info"];

export default function FormStepper({ setMainHeading }) {
  const [currentStep, setCurrentStep] = useState(0);
  const [open, setOpen] = useState(false);
  const [showThankyou, setShowThankyou] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    color: "",
  });
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState();
  const onStepIncrement = () => {
    const incrementStep = currentStep + 1;
    setCurrentStep(incrementStep);
  };
  const onStepDecrement = () => {
    const decrementStep = currentStep - 1;
    setCurrentStep(decrementStep);
  };

  const getStepOneData = (data) => {
    trackStepCompletion(1);
    pageViewed("Step 2");
    setInfo({ ...info, ...data });
  };
  const getStepTwoData = (data) => {
    setInfo({ ...info, ...data });
    trackStepCompletion(2);
    pageViewed("Step 3");
  };
  let tryCount = 0;

  const trackConversionEvent = (price) => {
    // ReactGA.event("purchase", {
    //   category: "Conversion",
    //   action: "purchase",
    //   value: price,
    //   transaction_id: `T-${Math.random().toString().slice(2, 8)}`,
    //   currency: "GBP",
    // });
    ReactGA.event("Booking Created", {
      category: "Conversion",
      action: "beta",
      value: price,
    });
  };

  const onSubmit = async () => {
    tryCount++;
    const meta = retrieveData("meta");
    const {
      origin: startPoint,
      destination: endPoint,
      inBetweenArray: middlePoints,
    } = processArray(info.coordinates);
    const dataToSend = {
      ...info,
      startPoint,
      endPoint,
      middlePoints,
      ...meta,
      dateTime: mergeTimeAndDate(info.date, info.time),
      status: "pending-review",
    };

    delete dataToSend.coordinates;
    delete dataToSend.time;
    delete dataToSend.date;
    delete dataToSend.acceptMarketing;
    if (loading) return;
    setLoading(true);
    try {
      const response = await createSale(dataToSend);
      trackConversionEvent(dataToSend.price);
      pageViewed("Booking created");
      if (response) {
        setLoading(false);
        setSnackbar({
          open: true,
          message: "Booked successfully",
          color: "green",
        });
        setMainHeading("Booking Confirmed!");
        localStorage.clear();
        setOpen(false);
        window.location.href =
          "https://smuve.uk/domestic-removals/booking-confirmed/";
      }
    } catch (err) {
      setLoading(false);
      console.log("inError");
      if (tryCount < 3) {
        await onSubmit();
      }
    }
  };
  const getStepThreeData = async (data) => {
    const meta = retrieveData("meta");
    setInfo({ ...info, ...data, ...meta });
    trackStepCompletion(3);
    pageViewed("Booking summary");
    setOpen(true);
  };
  const handleSnackbarClose = () => {
    setSnackbar({ open: false, message: "", color: "" });
  };
  const onBookAnother = () => {
    setShowThankyou(false);
    setCurrentStep(0);
    setMainHeading("Get Quote \n & \n Book A Removal Job");
  };

  // useEffect(() => {
  //   try {
  //     if (scripts) {
  //       const {
  //         bookingFormStep1,
  //         bookingFormStep2,
  //         bookingFormStep3,
  //         bookingFormStep4,
  //       } = scripts;

  //       const script = document.createElement("script");
  //       script.src =
  //         currentStep === 0
  //           ? bookingFormStep1
  //           : currentStep === 1
  //           ? bookingFormStep2
  //           : currentStep === 2
  //           ? bookingFormStep3
  //           : open
  //           ? bookingFormStep4
  //           : "";
  //       script.async = true;
  //       // document.body.appendChild(script);
  //       return () => {
  //         // document.body.removeChild(script);
  //       };
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // }, [currentStep, scripts]);

  const [showTimer, setShowTimer] = useState(false);
  const [showQuote, setShowQuote] = useState(false);
  return (
    <Box sx={{ width: "100%" }}>
      {showThankyou ? (
        <Thankyou onBookAnother={onBookAnother} />
      ) : (
        <>
          {/* dont remove this */}
          {showTimer && (
            <TimerToast
              setShowQuote={setShowQuote}
              setShowTimer={setShowTimer}
              setCurrentStep={setCurrentStep}
            />
          )}

          <Stepper
            activeStep={currentStep}
            alternativeLabel
            sx={{
              "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line": {
                borderColor: "#1b66b2",
              },
              "& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
                borderColor: "#1b66b2",
              },
            }}
          >
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel
                  StepIconProps={{
                    sx: {
                      color:
                        index === currentStep
                          ? "primary" // Active step
                          : index < currentStep
                          ? "primary" // Completed steps
                          : "grey.500", // Upcoming steps
                    },
                  }}
                >
                  <span
                    style={{
                      color:
                        index === currentStep
                          ? "#1b66b2" // Active label color (primary)
                          : index < currentStep
                          ? "#1b66b2" // Completed label color
                          : "#757575", // Inactive label color (grey)
                    }}
                  >
                    {label}
                  </span>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
          {currentStep === 0 && (
            <ParcelInformationForm
              showQuote={showQuote}
              setShowQuote={setShowQuote}
              setShowTimer={setShowTimer}
              getStepOneData={getStepOneData}
              onStepIncrement={onStepIncrement}
            />
          )}
          {currentStep === 1 && (
            <DateTimeForm
              getStepTwoData={getStepTwoData}
              onStepIncrement={onStepIncrement}
              onStepDecrement={onStepDecrement}
            />
          )}
          {currentStep === 2 && (
            <PersonalInformationForm
              onStepDecrement={onStepDecrement}
              getStepThreeData={getStepThreeData}
            />
          )}
        </>
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
      >
        <SnackbarContent
          style={{
            backgroundColor: snackbar.color,
          }}
          message={<span>{snackbar.message}</span>}
        />
      </Snackbar>

      <ModalWrapper
        modalTitle={"Booking Summary"}
        // modalHeading={""}
        src={require("../assets/logo.png")}
        open={open}
        setOpen={setOpen}
        onSuccess={onSubmit}
        loading={loading}
      >
        <BookingSummary info={info} />
      </ModalWrapper>
    </Box>
  );
}
